import React from 'react'
import withLayout from '../../../layout/withLayout'
import ContentBox from '../../../layout/component/ContentBox'
import Table from '../../../table/component/Table'
import setColumnList from './set-column-list'
import shopScanColumnList from './shop-scan-column-list'
import inShopScanColumnList from './in-shop-scan-column-list'
import treatmentColumnList from './treatment-column-list'
import refinementColumnList from './refinement-column-list'
import { lifecycle } from 'recompose'
import { PAYMENT_METHOD_SELECT } from '../../state/const'
import { getStoreDropDown } from '../../../store/util/renderStoreName'
import { COUNTRY_CODE_LIST } from '../../../internationalization/const'
import TableColumnSelector from '../../../table/component/TableColumnSelector'

const getColumnList = (type) => {
    switch (type) {
    case 'set':
        return setColumnList
    case 'shop-scan':
    case 'shop-scan-new':
        return shopScanColumnList
    case 'check-in':
    case 'in-shop-scan':
    case 'in-shop-scan-new':
        return inShopScanColumnList
    case 'treatment':
    case 'treatment-new':
    case 'refinement-production':
        return treatmentColumnList
    default:
        return refinementColumnList
    }
}


const TITLE = {
    'set': 'Set',
    'treatment': 'Treatment',
    'treatment-new': 'Treatment New',
    'end-of-treatment': 'End Of Treatment',
    'shop-scan': 'Shop Scan',
    'shop-scan-new': 'Shop Scan New',
    'in-shop-scan': 'Clinic 3D-Scan',
    'in-shop-scan-new': 'Clinic 3D-Scan New',
    'check-in': 'Clinic Check-In',
    'retainer': 'Retainer',
    'retainer-new': 'Retainer New',
    'refinement-set': 'Refinement Set',
    'refinement-booking': 'Refinement Shop Booking',
    'refinement-shop': 'Refinement Shop Scan',
    'refinement-shop-new': 'Refinement Shop Scan New',
    'refinement-production': 'Refinement Treatment',
    'escalation': 'Escalation',
    'implant-3d-scan': 'Implant Clinic 3D-Scan',
    'implant-plan': 'Implant Plan',
    'implant-treatment': 'Implant Treatment',
    'retainer-refinement': 'Retainer Refinement',
    'retainer-refinement-new': 'Retainer Refinement New',
}

const SalesOrderSearch = ({ type, tableData, changeFilter, toggleSort, toggleMultiSort, gotoPage, navigateToSalesOrder, toggleColumnVisibility }) => {
    const title = TITLE[type]
    const columnList = getColumnList(type)

    return (
        <ContentBox title={title}>
            <TableColumnSelector
                resultsNumber={tableData.objectList.length}
                hiddenColumns={tableData.hiddenColumns}
                columnList={columnList}
                toggleColumnVisibility={toggleColumnVisibility}
            />

            <Table
                {...tableData}
                changeFilter={changeFilter}
                toggleSort={toggleSort}
                toggleMultiSort={toggleMultiSort}
                gotoPage={gotoPage}
                idProperty="id"
                columnList={columnList}
                onRowClick={(salesOrder) => {
                    navigateToSalesOrder(salesOrder.id)
                }}
                filterSetting={{
                    vip: {
                        type: 'select',
                        valueList: [
                            {
                                id: '0',
                                value: 'no influencer',
                            },
                            {
                                id: '1',
                                value: 'influencer',
                            },

                        ],
                    },
                    paymentMethod: {
                        type: 'select',
                        valueList: PAYMENT_METHOD_SELECT,
                    },
                    paymentReceived: {
                        type: 'select',
                        valueList: [
                            {
                                id: '0',
                                value: 'no',
                            },
                            {
                                id: '1',
                                value: 'yes',
                            },

                        ],
                    },
                    store: {
                        type: 'select',
                        valueList: getStoreDropDown(),
                    },
                    countryCode: {
                        type: 'select',
                        valueList: COUNTRY_CODE_LIST,
                    },
                    status: {
                        type: 'input',
                        beforeQuery: (value) => {
                            if (!value) {
                                return value
                            }
                            return value.replace(/ /g, '_')
                        },
                        beforeRender: (value) => {
                            if (!value) {
                                return value
                            }
                            return value.replace(/_/g, ' ')
                        },
                    },
                }}
            />
        </ContentBox>
    )
}


export default lifecycle({
    componentDidMount() {
        this.props.initialTableQuery()
        if (this.props.initialColumnsVisibility) {
            this.props.initialColumnsVisibility()
        }
    },
})(withLayout(SalesOrderSearch))



// WEBPACK FOOTER //
// ./src/modules/sales-order/component/search/SalesOrderSearch.js